import AppContainer from "../Structure/AppContainer";
import React, { useContext, useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import AuthContext from "../../Context/AuthContext";
import useStateCallback from "../../util/customHooks/useStateCallback";
import ajaxFuelTanks from "../../util/remote/ajaxFuelTanks";
import RegisterFuelTankModal from "./RegisterFuelTankModal";
import UpdateStationFuelPriceModal from "./UpdateStationFuelPriceModal";

const ViewFuelTanks = () => {
  const { userId } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  var station_idd = Number(window.localStorage.getItem("FuelFy@station_id"));

  // NOW WE STORE TANKS, NOT CATEGORIES
  const [fuelTanks, setFuelTanks] = useState([]);

  const [viewType, setViewType] = useState("table view");
  const [station_id, setstation_id] = useState(station_idd);

  // Fetch Fuel Tanks
  const fetchFuel_tanks = async () => {
    setLoading(true);

    const data = { station_id: station_id };
    const response = await ajaxFuelTanks.list_fuel_tanks(data);

    if (response.status === "OK") {
      setFuelTanks(response.details || []);
    } else {
      toast.error(response.message);
    }

    setLoading(false);
  };

  useEffect(() => {
    fetchFuel_tanks();
  }, [station_id]);

  const toggleView = (type) => setViewType(type);

  const [update, setUpdate] = useStateCallback(false);
  const handleViewDetails = (tank) => {
    setUpdate(false, () =>
      setUpdate(
        <UpdateStationFuelPriceModal data={tank} func={fetchFuel_tanks} />
      )
    );
  };

  const [Registers, setRegisters] = useStateCallback(false);
  const handleRegister = () => {
    setRegisters(false, () =>
      setRegisters(<RegisterFuelTankModal func={fetchFuel_tanks} />)
    );
  };

  // Action buttons
  const filteredActions = [
    {
      label: "card view",
      icon: "fa-regular fa-address-card",
      className: "btn btn-success btn-sm",
      onClick: () => toggleView("card view"),
    },
    {
      label: "table view",
      icon: "fa-solid fa-table",
      className: "btn btn-success btn-sm",
      onClick: () => toggleView("table view"),
    },
    {
      label: "Register Tank",
      icon: "fa-solid fa-file-pen",
      className: "btn btn-info btn-sm",
      onClick: () => handleRegister(),
    },
  ].filter((action) => action.label !== viewType);

  return (
    <AppContainer
      title="Fuel Tanks"
      previousPageTitle="Dashboard"
      actions={filteredActions}
    >
      <div className="container-fluid">
        <Toaster />
        {update}
        {Registers}

        {loading ? (
          <div className="text-center my-5 fs-5 text-muted">
            Loading Fuel Tanks...
          </div>
        ) : fuelTanks.length === 0 ? (
          <div className="text-center my-5 fs-5 text-muted">
            No Fuel Tanks Available
          </div>
        ) : viewType === "table view" ? (
          <>
            <div className="row">
              <div className="col-sm-12 col-xl-12 col-lg-12">
                <div className="card custom-card">
                  <div className="card-body">
                    <h6 className="card-title mb-1">Fuel Tanks</h6>
                    <p className="text-muted card-sub-title">
                      List of registered fuel tanks
                    </p>

                    <div className="table-responsive">
                      <table className="table table-bordered text-nowrap mb-0">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Tank Code</th>
                            <th>Capacity</th>
                            <th>Fuel Category</th>
                            <th>Status</th>
                            <th>Created At</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {fuelTanks.map((tank, index) => (
                            <tr key={tank.id}>
                              <td>{index + 1}</td>
                              <td>{tank.Tank_code}</td>
                              <td>{tank.capacity} litres</td>
                              <td>{tank.fuel_category}</td>

                              <td>
                                <span
                                  className={`badge ${
                                    tank.status === "1"
                                      ? "bg-success"
                                      : "bg-danger"
                                  }`}
                                >
                                  {tank.status === "1" ? "Active" : "Inactive"}
                                </span>
                              </td>

                              <td>{tank.created_at}</td>
                              <td>
                                <button
                                  className="btn btn-sm btn-info"
                                  onClick={() => handleViewDetails(tank)}
                                >
                                  <i className="fe fe-edit-2"></i>
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="row">
              {fuelTanks.map((tank) => (
                <div className="col-md-4 col-lg-3 mb-3" key={tank.id}>
                  <div
                    className="card h-100"
                    style={{
                      borderRadius: "12px",
                      boxShadow: "4px 4px 12px rgba(0,0,0,0.1)",
                    }}
                  >
                    <div className="card-body text-center">
                      <h6 className="mb-1">{tank.Tank_code}</h6>
                      <small className="d-block text-muted">
                        Capacity: {tank.capacity} litres
                      </small>
                      <small className="d-block text-muted">
                        Fuel: {tank.fuel_category}
                      </small>
                      <small className="d-block text-muted">
                        Created: {tank.created_at}
                      </small>

                      <div className="mt-2">
                        <span
                          className={`badge px-3 py-1 ${
                            tank.status === "1" ? "bg-success" : "bg-danger"
                          }`}
                        >
                          {tank.status === "1" ? "Active" : "Inactive"}
                        </span>
                      </div>

                      <div className="d-flex justify-content-center mt-3">
                        <button
                          className="btn btn-sm btn-outline-primary px-3"
                          onClick={() => handleViewDetails(tank)}
                        >
                          <i className="fe fe-edit-2"></i> Edit
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </AppContainer>
  );
};

export default ViewFuelTanks;
